import React, {Component} from 'react';
import axios from 'axios';
import clsx from 'clsx';
import { UserContext } from '../components/userContext';
import { useHistory, withRouter } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Container, IconButton } from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';
import { withStyles } from '@material-ui/styles';
import OpenInNewRoundedIcon from '@material-ui/icons/OpenInNewRounded';
import { Translate } from '@material-ui/icons';


const useStyles = (theme) => ({
  root: {
    overflowX: 'hidden',
    width: 'calc(100vw - 240px)', 
    margin: '0 auto', 
    '@media (max-width:950px)': {
      width: 'calc(100vw - 87px)',
    },
    '@media (max-width:775px)': {
      width: '100%'
    },
  },
  rootOpen: {
    width: 'calc(100vw - 240px - 240px)', 
    '@media (max-width:950px)': {
      width: '100%'
    },
  },
  detail: {
    transition: 'all 0.5s ease',
    boxSizing: 'border-box',
    minHeight: 300,
    paddingRight: 35,
    fontSize: 16,
    transform: 'translateX(355px)',
    // overflow: 'hidden',
    width: 'calc(100vw - 320px - 240px - 35px - 2px)',
    '@media (max-width:950px)': {
      width: 'calc(100vw - 320px - 87px - 35px - 2px)',
    },
    '@media (max-width:775px)': {
      width: '100%',
      transform: 'translate(0px, 0px)',
      // background: 'linear-gradient(0deg, rgba(8, 8, 8, 0.975) 75%, transparent)',
      backgroundColor: 'rgba(8, 8, 8, 0.975)',
      boxShadow: theme.shadows[8],
      padding: 30,
      fontSize: 15,
      // paddingTop: 300,
      height: '100%',
    },
    '@media (max-width:599px)': {
      padding: 12,
      // paddingTop: 300,
      fontSize: 14,
    },
    '& .imgMobile': {
      display: 'none',
      // borderRadius: 4,
      height: 240,
      marginBottom: 16,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      '@media (max-width:775px)': {
        display: 'block'
      },
    },
    '& .imgMobileOpen': {
      '@media (max-width:1000px)': {
        display: 'block'
      },
    },
    '& .title': {
      fontSize: 36, 
      fontWeight: 500, 
      lineHeight: '36px',
      '@media (max-width:775px)': {
        fontSize: 28, 
        lineHeight: '28px',
      },
      '@media (max-width:599px)': {
        fontSize: 24, 
        lineHeight: '24px',
      }
    },
    '& .genre': {
      marginBottom: 8,
      '& span': {
        padding: '2px 5px', 
        marginRight: 8,
        borderRadius: 2,
        color: 'rgba(0, 0, 0, 1)',
        fontWeight: 500,
        backgroundColor: 'rgb(163, 102, 255)',
        boxShadow: theme.shadows[3],
      }
    }
  },
  detailOpen: {
    width: 'calc(100vw - 320px - 240px - 240px - 35px - 2px)',
    '@media (max-width:1000px)': {
      width: '100%',
      transform: 'translate(0px, 0px)',
      // background: 'linear-gradient(0deg, rgba(8, 8, 8, 0.975) 75%, transparent)',
      backgroundColor: 'rgba(8, 8, 8, 0.975)',
      boxShadow: theme.shadows[8],
      padding: 30,
      fontSize: 15,
      // paddingTop: 300,
      height: '100%',
    },
  },
  container: {
    width: 'calc(100vw - 240px - 35px)',
    '@media (max-width:950px)': {
      width: 'calc(100vw - 87px - 35px)',
    },
    '@media (max-width:775px)': {
      transform: 'translateX(0px)',
      width: '100%'
    },
    transform: 'translateX(35px)',
    boxShadow: theme.shadows[8],
    backgroundColor: 'rgba(8, 8, 8, 0.975)',
    // border: '4px solid rgba(8, 8, 8, 0.975)',
    '& .innerContainerOpen': {
      width: 'calc(100vw - 240px - 240px - 35px)', 
      '@media (max-width:1000px)': {
        width: '100%',
        padding: 0,
      },
    },
    '& .innerContainer': {
      height: '100%', 
      width: 'calc(100vw - 240px - 35px)', 
      padding: '35px 0', 
      '@media (max-width:950px)': {
        width: 'calc(100vw - 87px - 35px)',
      },
      '@media (max-width:775px)': {
        width: '100%',
        padding: 0,
      },
    },
    '& .imgContainerOpen': {
      width: '100%',
      transform: 'translateX(0px)',
      '@media (max-width:1000px)': {
        transform: 'translateX(0px)',
        width: '100%',
        height: '100%'
      },
    },
    '& .imgContainer': {
      transition: 'all 0.5s ease',
      boxSizing: 'border-box',
      width: 320,
      // minWidth: 320,
      // maxWidth: 320,
      transform: 'translateX(-35px)',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      border: '2px solid rgba(8, 8, 8, 0.975)',
      backgroundColor: 'rgba(8, 8, 8, 0.975)',
      boxShadow: theme.shadows[3],
      '@media (max-width:775px)': {
        transform: 'translateX(0px)',
        width: '100%',
        height: '100%'
      },
      '@media (max-width:599px)': {
        minWidth: 270,
      },
    },
  },
  containerOpen: {
    width: 'calc(100vw - 240px - 240px - 35px)',
    '@media (max-width:1000px)': {
      width: '100%',
      transform: 'translateX(0px)',
    },
  },
});

class MovieDetail extends React.Component { 
	static contextType = UserContext;

  constructor(props) {
    super(props);
    this.state = {
      movie: {},
    }
  }

  componentDidMount() {
    const itemId = this.props.match.params.itemId;
    console.log(itemId)
    axios.get(`https://backendexample.sanbersy.com/api/data-movie/${itemId}`).then(res => {
      let result = res.data;
      if (Boolean(result.title) === false) result.title = " ";
      if (Boolean(result.image_url) === false) result.image_url = " ";
      if (Boolean(result.genre) === false) result.genre = " ";
      if (Boolean(result.rating) === false) result.rating = 0;
      if (Boolean(result.year) === false) result.year = 0;
      if (Boolean(result.duration) === false) result.duration = 0;
      if (Boolean(result.description) === false) result.description = " ";
      if (Boolean(result.review) === false) result.review = " ";
      let title = result.title.charAt(0).toUpperCase() + result.title.slice(1);
      let genre = result.genre.charAt(0).toUpperCase() + result.genre.slice(1);
      let description = result.description.charAt(0).toUpperCase() + result.description.slice(1);
      let review = result.review.charAt(0).toUpperCase() + result.review.slice(1);
      this.setState({movie: {...result, title: title, genre: genre, description: description, review: review} }); 
    });
  }

  render() {
    const { classes } = this.props;
    const { open } = this.context;
    return(
      <div className={clsx(classes.root, open && classes.rootOpen)}>
        <div className={clsx(classes.container, open && classes.containerOpen)}>
          <div className={clsx("innerContainer", open && "innerContainerOpen")}>
            <div className={clsx("imgContainer", open && "imgContainerOpen")} style={{backgroundImage: `url(${this.state.movie.image_url})`}} >
              <div className={clsx(classes.detail, open && classes.detailOpen)}>
                <div className={clsx("imgMobile", open && "imgMobileOpen")} style={{backgroundImage: `url(${this.state.movie.image_url})`}} ></div>
                <div className='title'>{this.state.movie.title} ({this.state.movie.year})</div>
                <div style={{color: 'rgb(144, 144, 144)'}}>
                  <span 
                    style={{color: 'rgb(144, 144, 144)', lineHeight: '16px'}}
                  >
                    {(this.state.movie.duration/60).toString().split('.')[0]}hr {this.state.movie.duration == 0 ? null : this.state.movie.duration % 60}min 
                  </span>
                </div>
                <div style={{display: 'flex', fontSize: 15, alignItems: 'center', marginBottom: 8, marginLeft: '-4px'}}>
                  <Rating value={this.state.movie.rating/2} precision={0.5} readOnly size="medium" style={{marginRight: 8}}/>
                  <span style={{color: 'rgb(144, 144, 144)', fontSize: 14, lineHeight: 'normal'}}>{this.state.movie.rating}/10</span>
                </div>
                {this.state.movie.genre && 
                  <div className="genre">
                    {this.state.movie.genre.includes(',') 
                      ? this.state.movie.genre.split(',').map((el, idx) => {
                        return (
                          <span>
                            {el.trim().charAt(0).toUpperCase() + el.trim().slice(1)}
                          </span> 
                        )}) 
                      : <span>{this.state.movie.genre.trim().charAt(0).toUpperCase() + this.state.movie.genre.trim().slice(1)}</span>
                    }
                  </div>
                }
                <div style={{marginBottom: 8}}>
                  {this.state.movie.description}
                </div>
                <div>
                  <span><span style={{color: 'rgb(144, 144, 144)'}}>Review : </span> {this.state.movie.review}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }   
}

export default withStyles(useStyles)(MovieDetail);
 